import { render, staticRenderFns } from "./ProtectedUserStatusModal.vue?vue&type=template&id=0b88936a"
import script from "./ProtectedUserStatusModal.vue?vue&type=script&lang=js"
export * from "./ProtectedUserStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports